<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref, computed} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import { useCrmInstallData } from '../CrmInstallData';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	
	const emit = defineEmits(['nextStep','updateForm']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/user" }
	});
	const { errorMessage, isError, progress, submitOnEnter,
			sendForm, nextStep, errEmptyStringClass } = useBaseStep(props,emit,validateForm);
		
	const { getData   } = useCrmInstallData();

	
	function validateForm(): boolean {
		if (!Boolean(props.form.userPassword)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		else if (props.form.userPassword!==props.form.userPassword2) {
			errorMessage.value=msg("err.passwordNotEqual");
			return false;
		}
		
		if (!Boolean(props.form.userPassword2)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.serialNumber)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		if (!Boolean(props.form.frontUrl)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		return true;
	}
	
	function onSubmit(): void {
		sendForm(props.form,'Done');
	}
	
	let installPath = "/install/install.jsp";
	let path: string = window.location.pathname.slice(0,-1*installPath.length);
	emit('updateForm', 'frontUrl', window.location.protocol + "//" + window.location.host + path);

	getData(props.restApi+"/serialNumber")
			.then((data)=>{
				if (data && data.serialNumber) {
					emit('updateForm', 'serialNumber', data.serialNumber);
				}
			});
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.title.users")}}</div>
	<form @submit.prevent>
	<table border="0" cellspacing="0" class="formTable">
		<tr>
			<th><b>{{msg("install.user.login")}}:</b></th>
			<td><input type="text" value="admin" disabled size="10"></td>
		</tr>
		<tr>
			<th><b>{{msg("install.user.password")}}:</b></th>
			<td><input type="password" :value="form.userPassword" size="10" maxlength="16" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'userPassword', $event.target.value)" :class="errEmptyStringClass(form.userPassword)"></td>
		</tr>
		<tr>
			<th><b>{{msg("install.user.password2")}}:</b></th>
			<td><input type="password" :value="form.userPassword2" size="10" maxlength="16" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'userPassword2', $event.target.value)" :class="errEmptyStringClass(userPassword2)"></td>
		</tr>
		<tr>
			<td colspan="2">&nbsp;</td>
		</tr>
		<tr>
			<th><b>{{msg("install.app.serialNumber")}}:</b></th>
			<td><input type="text" :value="form.serialNumber" size="36" maxlength="25" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'serialNumber', $event.target.value)" :class="errEmptyStringClass(form.serialNumber)"></td>
		</tr>
		<tr>
			<th><b>{{msg("install.app.outerURL")}}:</b></th>
			<td><input type="text" :value="form.frontUrl" size="36" maxlength="64" @keypress="submitOnEnter($event,onSubmit)"
					@input="$emit('updateForm', 'frontUrl', $event.target.value)" :class="errEmptyStringClass(form.frontUrl)"></td>
		</tr>
		<tr>
			<td colspan="2"><error-msg :show="isError" :msg="errorMessage"/></td>
		</tr>
		<tr>
			<td style="padding-top:10px" colspan="2">
				<button @click="nextStep('Application')" class="sbutton">
					<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
				</button>
				&nbsp;
				<progress-button @click="onSubmit" :progress="progress"
					class="button" icon="page-next-16-full">
					{{msg('install.butt.next')}}
				</progress-button>
			</td>
		</tr>
	</table>
	</form>
	</div>
</template>

